import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_SERVICE } from '@/api/hris-onboarding';

const getHrisTools = async () => {
  try {
    const result = await API_SERVICE.getHrisTools();
    return result;
  } catch {
    // best-effort; ignore failures
  }
};

export const fetchHrisTools = createAsyncThunk(
  'integrations/fetch/all',
  getHrisTools,
  {
    condition: (_userId, { getState }) => {
      const { integrations } = getState();
      return integrations?.data?.length === 0;
    },
  }
);
